import React from 'react';
import styles from './buttonsSection.module.scss';

export const ButtonsSection = ({ children }) => {
    return <div className={styles['buttons-section']}>{children}</div>;
};
